import { NumberInput, Select, Stack } from "@mantine/core";

const NOTICE_PERIOD_PRESETS = [0, 15, 30, 45, 60, 90];
const NOTICE_PERIOD_CUSTOM_VALUE = "custom";
const NOTICE_PERIOD_CUSTOM_DEFAULT = 1;
const NOTICE_PERIOD_MIN_DAYS = 0;
const NOTICE_PERIOD_MAX_DAYS = 730;
const NOTICE_PERIOD_OPTIONS = [
  ...NOTICE_PERIOD_PRESETS.map((days) => ({
    value: String(days),
    label: days === 0 ? "Immediate" : `${days} days`,
  })),
  { value: NOTICE_PERIOD_CUSTOM_VALUE, label: "Custom notice period" },
];

type Props = {
  value?: number | null;
  onChange: (days: number | undefined) => void;
  disabled?: boolean;
  label?: string;
  description?: string;
  error?: React.ReactNode;
};

export function AvailabilityChips({
  value,
  onChange,
  disabled,
  label = "Notice period",
  description = "Select when you would be available to join",
  error,
}: Props) {
  const isPreset = value != null && NOTICE_PERIOD_PRESETS.includes(value);
  return (
    <Stack gap="var(--axio-unit-16)">
      <Select
        label={label}
        description={description}
        placeholder="Select notice period"
        value={isPreset ? String(value) : value == null ? null : NOTICE_PERIOD_CUSTOM_VALUE}
        data={NOTICE_PERIOD_OPTIONS}
        disabled={disabled}
        clearable
        size="md"
        error={error}
        onChange={(next) => {
          if (!next) {
            onChange(undefined);
            return;
          }
          if (next === NOTICE_PERIOD_CUSTOM_VALUE) {
            onChange(
              value != null && !NOTICE_PERIOD_PRESETS.includes(value)
                ? value
                : NOTICE_PERIOD_CUSTOM_DEFAULT,
            );
            return;
          }
          onChange(Number(next));
        }}
      />
      {!isPreset && value != null && (
        <NumberInput
          label="Custom days"
          min={NOTICE_PERIOD_MIN_DAYS}
          max={NOTICE_PERIOD_MAX_DAYS}
          disabled={disabled}
          size="md"
          value={value}
          onChange={(n) => onChange(typeof n === "number" ? n : undefined)}
        />
      )}
    </Stack>
  );
}
